import DateHandler from '@/shared/utils/date-format';

export default class ContractBilling {
  enabled: boolean;

  competenceStart: string;

  competenceEnd: string;

  constructor(obj: any = {}) {
    this.enabled = obj.enabled;
    this.competenceStart = obj.competenceStart || '';
    this.competenceEnd = obj.competenceEnd || '';
  }

  public static of(obj: any = {}): ContractBilling {
    return new ContractBilling(obj || {});
  }

  public static ofList(obj: any[]): ContractBilling[] {
    return obj.map(this.of);
  }

  get validity(): string {
    return `Vigência: ${DateHandler.localDateToLocal(this.competenceStart)} - 
      ${DateHandler.localDateToLocal(this.competenceEnd)}`
  }
}
